export default "__VITE_PUBLIC_ASSET__b4cce9c4__"